<template>
  <div class="login">
    <section>
      <h1>Connectez-vous à votre compte <b>et continuez votre aventure !</b></h1>
      <form @submit.prevent="handleLogin">
        <div>
          <label for="email">Email</label>
          <input
            id="email"
            v-model="email"
            autocomplete="one-time-code"
            type="email"
            :pattern="emailPattern"
            :title="emailTitle"
            required
            :disabled="loading"
          />
        </div>
        <div>
          <label for="password">Mot de passe</label>
          <input
            id="password"
            v-model="password"
            type="password"
            autocomplete="one-time-code"
            required
            name="password"
            :disabled="loading"
          />
        </div>
        <button type="submit" id="login" class="btnPrimary" :disabled="loading">
          {{ loading ? 'Connexion...' : 'Connexion' }}
        </button>
        <p id="forgotPassword" @click="handleForgotPassword" :class="{ disabled: loading }">
          Mot de passe oublié ?
        </p>
        <p class="link">Vous n'avez pas de compte ? <a href="register.html">Inscrivez-vous</a></p>
      </form>
    </section>

    <section>
      <img class="logo" :src="logoUrl" alt="Logo SalesRidge">
    </section>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useAuth } from '../composables/useAuth'
import logoImg from '../img/logo.png'

export default {
  name: 'LoginApp',
  setup() {
    const email = ref('')
    const password = ref('')
    const { loading, login, resetPassword } = useAuth()
    const logoUrl = logoImg
    const emailPattern = '^(?!.*@(gmail|yahoo|hotmail|aol|hotmail.co.uk|hotmail.fr|msn|yahoo.fr|wanadoo|orange|comcast|yahoo.co.uk|yahoo.com.br|yahoo.co.in|live|rediffmail|free.fr|gmx.de|web.de|yandex|ymail|libero|outlook|uol|bol|mail.ru|cox|hotmail.it|sbcglobal|sfr|live.fr|verizon|live.co.uk|googlemail|yahoo.es|ig|live.nl|bigpond|terra.com.br|yahoo.it|neuf|yahoo.de|alice.it|rocketmail|att|laposte|facebook|bellsouth|yahoo.in|hotmail.es|charter|yahoo.ca|yahoo.com.au|rambler|hotmail.de|tiscali.it|shaw|yahoo.co.jp|sky|earthlink|optonline|freenet|t-online|aliceadsl|virgilio|home.nl|qq|telenet|me|yahoo.com.ar|tiscali.co.uk|yahoo.com.mx|voila|gmx|mail|planet|tin|live.it|ntlworld|arcor|yahoo.co.id|frontiernet|hetnet|live.com.au|yahoo.com.sg|zonnet|club-internet|juno|optusnet|blueyonder|bluewin|skynet|sympatico|windstream|mac|centurytel|chello|live.ca|aim|bigpond.net.au)+$).*$'
    const emailTitle = 'Veuillez ajouter une adresse email professionnelle. Les adresses email personnelles (ex : gmail, yahoo, outlook) ne peuvent pas être utilisées pour créer un compte sur notre plateforme.'

    async function handleLogin() {
      const result = await login(email.value, password.value)
      if (!result.success) {
        alert(result.error)
      }
    }

    async function handleForgotPassword() {
      const result = await resetPassword(email.value)
      if (result.success) {
        alert(result.message)
      } else {
        alert(result.error)
      }
    }

    return {
      email,
      password,
      loading,
      logoUrl,
      emailPattern,
      emailTitle,
      handleLogin,
      handleForgotPassword
    }
  }
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
